import React from 'react';
import { MARQUEE_ITEMS } from '../mock';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="border-y border-black/10 bg-white overflow-hidden py-6">
      <div className="marquee-track flex gap-10 whitespace-nowrap">
        {items.concat(items).map((it, i) => (
          <span key={i} className="display-font text-[2rem] md:text-[2.4rem] text-black flex items-center gap-10">
            {it}
            <span className="accent-red text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
